import React, { LiHTMLAttributes } from 'react';

import * as styles from './MentionsMenu.css';
import { MentionTypeaheadOption } from '@mutiny-pkg/bin-ui/src/richtext/MentionsPlugin/MentionTypeaheadOption';
import { Box } from '@mutiny-pkg/dumpster-ui/components/Box';
import { Flex } from '@mutiny-pkg/dumpster-ui/components/Flex';
import { Typography } from '@mutiny-pkg/dumpster-ui/components/Typography';

export const MentionsMenu = ({ children, ...props }: { children: React.ReactNode }) => {
  return (
    <ul
      {...props}
      className={styles.mentionList}
      style={{
        position: 'relative',
        bottom: 'auto',
      }}
    >
      {children}
    </ul>
  );
};

type MentionMenuItemProps = LiHTMLAttributes<HTMLElement> & {
  index: number;
  isSelected: boolean;
  option: MentionTypeaheadOption;
};

export const MentionsMenuItem = ({ index, isSelected, option, ...props }: MentionMenuItemProps) => {
  return (
    <li
      key={option.key}
      tabIndex={-1}
      className={styles.mentionListItem({
        selected: isSelected,
      })}
      ref={option.setRefElement}
      role="option"
      aria-selected={isSelected}
      id={`typeahead-item-${index}`}
      {...props}
    >
      <Flex.Container justifyContent="space-between" alignItems="center" fullWidth gap="4u">
        <Flex.Container
          alignItems="center"
          gap="4u"
          paddingLeft="4u"
          style={{
            maxHeight: '24px',
            fontSize: '16px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '600px',
          }}
        >
          {option.iconComponent && (
            <>
              <option.iconComponent />
              &nbsp;
            </>
          )}
          <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={option.label}>
            {option.label}
          </span>
        </Flex.Container>
        {typeof option.completeness === 'number' && (
          <Flex.Container alignItems="center" flexDirection="row" justifyContent="flex-end" paddingRight="4u">
            <Typography font="body1" fontWeight="regular" color="secondary">
              {option.completeness}%
            </Typography>
          </Flex.Container>
        )}
      </Flex.Container>
    </li>
  );
};

type MentionsMenuGroupHeaderProps = {
  groupLabel: string;
};

export const MentionsMenuGroupHeader = ({ groupLabel }: MentionsMenuGroupHeaderProps) => {
  return (
    <li>
      <Box paddingY="4u" paddingX="8u" display="flex" alignItems="center">
        <Typography font="heading3" as="span">
          {groupLabel}
        </Typography>
      </Box>
    </li>
  );
};
